<template>
  <div v-cloak class="Resource">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">解决方案</div>
        <div class="texts">
          囊括各行业数智化方案，共享数智化资源，共赢数智未来
        </div>
      </div>
    </div>

      <div class="Bread"><Bread :list="breadList" /></div>


    <!-- 中间内容 -->
    <div class="containers">
      <div class="flex bg-fff c-8a pa-l-10">
        <div
          class="pointer ma-r-50 ma-t-10 w-s-n"
          :class="0 == queryList.categoryId ? 'curStyle' : ''"
          @click="typeSwitch1(0, [])"
        >
          全部
        </div>
        <div class="flex f-wrap">
          <div
            v-for="(item, index) in typeList1"
            :key="index"
            class="ma-r-50 pointer ma-t-10"
            :class="item.Id == queryList.categoryId ? 'curStyle' : ''"
            @click="typeSwitch1(item.Id, item.Children)"
          >
            {{ item.Name }}
          </div>
        </div>
      </div>
      <div class="flex ma-t-10 c-8a ma-l-10">
        <div
          class="pointer"
          :class="0 == queryList.sortType ? 'curStyle' : ''"
          @click="bysortType(0)"
        >
          默认
        </div>
        <div
          class="pointer ma-l-50"
          :class="1 == queryList.sortType ? 'curStyle' : ''"
          @click="bysortType(1)"
        >
          日期
        </div>
        <div
          class="pointer ma-l-50"
          :class="2 == queryList.sortType ? 'curStyle' : ''"
          @click="bysortType(2)"
        >
          热度
        </div>
      </div>
      <div class="flex ma-t-10 c-8a">
        <div
          class="ma-l-10 c-pointer"
          @click="
            queryList.isstar = 0;
            loadDataList();
          "
          :class="queryList.isstar == 0 ? 'curStyle' : ''"
        >
          全部
        </div>
        <div
          class="ma-l-50 c-pointer"
          @click="
            queryList.isstar = 1;
            loadDataList();
          "
          :class="queryList.isstar == 1 ? 'curStyle' : ''"
        >
          星标
        </div>
      </div>
      <div class="flex ma-t-20 f-wrap">
        <div
          v-for="(item, index) in dataList"
          :key="index"
          :class="index%3==0?'ma-l-0':'ma-l-26'"
          class="w-30 ma-b-20 shadow bg-fff pa-10 pointer"
          @click="toPage('read', { id: item.Id })"
        >
          <div class="fon-18 bold title-item">{{ item.Name }}</div>
          <div class="box-imgwrap">
            <img
              v-if="item.Image"
              :src="item.Image"
              alt=""
              srcset=""
              class="width100 height100 img-item"
            />
            <img v-else src="../img/noimages.png" alt="" srcset="" class="width100 height100 img-item">
          </div>
          <!-- <div class="c-999">{{ item.intr }}</div> -->
          <div class="flex f-between ma-t-10">
            <div>
              <i class="iconfont icon-yanjing1"></i> {{ item.ViewCount }}
            </div>
            <div>
              <i class="iconfont icon-shijian"></i> {{ item.ReleaseTime }}
            </div>
          </div>
        </div>
      </div>
      <div class="fy">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="queryList.pageIndex"
          :page-size="queryList.pageSize"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<style lang="scss"  scoped>
.ma-l-26{
  margin-left: 26px;
}
.title-item {
  height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.img-item{
  // object-fit: cover;
}
.ma-r-50 {
  margin-right: 50px;
}
.o-x-scroll {
  overflow-x: scroll;
}
.o-x-auto {
  overflow-x: auto;
}
.w-s-n {
  white-space: nowrap;
}
.ma-l-88 {
  margin-left: 88px;
}
.fy {
  display: flex;
  justify-content: center;
  align-items: center;
}
.height100 {
  height: 100%;
}
.box-imgwrap {
  overflow: hidden;
  height: 200px;
}
.containers {
  width: 1200px;
  padding:20px;
  box-sizing: border-box;
  background: #fff;
  margin: 0 auto;
}
.curStyle {
  font-weight: 700;
  color: #234775;
}
.pointer {
  cursor: pointer;
}
.w-30 {
  width: 30%;
}
.Resource .swiper {
  width: 100%;
  height: 314px;
  background-image: url(../img/方案.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.f-wrap {
  flex-wrap: wrap;
}
</style>
<script>
import Bread from "../components/Bread.vue";
import { getType, getDatumList } from "../api";
// Import Swiper Vue.js components

// studycollect
export default {
  name: "About",
  components: {
    Bread,
  },
  data() {
    return {
      totals: 0, //一个分类下的总条数
      breadList: [
        {
          name: "解决方案",
          path: "/Datum",
        },
      ],
      typeList1: [],
      typeList2: [],
      dataList: [],
      queryList: {
        categoryId: 0, //分类id，为0时查询全部
        categoryId2: 0, //分类id，为0时查询全部
        title: "",
        sortType: 0, //排序类型 0 默认 1 日期 2 热度
        pageIndex: 1,
        pageSize: 12,
        isstar: 0,
      },
    };
  },

  created() {},
  beforeRouteEnter(to, from, next) {
    next();
  },

  // 其他页面进来时更新初始数据
  activated() {},
  computed: {},
  mounted() {
    this.info();
  },

  methods: {
    // 当前页改变时触发
    handleCurrentChange(e) {
      console.log(e);
      this.queryList.pageIndex = e;
      this.loadDataList();
    },
    //修改搜索条件
    typeSwitch1(index, Children) {
      this.queryList.categoryId = index;
      this.queryList.categoryId2 = 0;
      this.typeList2 = Children;
      this.loadDataList();
    },
    //修改搜索条件
    typeSwitch2(index) {
      this.queryList.categoryId2 = index;
      this.loadDataList();
    },
    //修改搜索条件,是否星标
    isstarChange() {
      this.queryList.isstar = this.queryList.isstar == 1 ? 0 : 1;
      this.loadDataList();
    },
    info() {
      getType().then((res) => {
        this.typeList1 = res.data.Data;
      });
      this.loadDataList();
    },
    //修改搜索条件
    bysortType(sortType) {
      this.queryList.sortType = sortType;
      this.loadDataList();
    },
    //获取列表数据
    loadDataList() {
      getDatumList(this.queryList).then((res) => {
        this.dataList = res.data.Data.List;
        //更新页码
        this.totals = res.data.Data.TotalCount;
      });
    },
    toPage(f, p) {
      switch (f) {
        case "read":
          this.$router.push({
            path: "/read",
            query: { id: p.id },
          });
          break;

        default:
          break;
      }
    },
  },
};
</script>
